import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { getAreasForCity } from '../../data/locations/areas';

interface NearbyAreasProps {
  city: string;
  state: string;
}

export default function NearbyAreas({ city, state }: NearbyAreasProps) {
  const normalizedCity = city.toLowerCase().replace(/\s+/g, '-');
  const areas = getAreasForCity(normalizedCity);

  if (areas.length === 0) return null;

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Service Areas Near {city}
          </h2>
          <p className="text-lg text-gray-600">
            Professional appliance repair services available in all areas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {areas.map((area) => (
            <Link
              key={area.value}
              to={`/locations/${state.toLowerCase()}/${normalizedCity}/area/${area.value}`}
              className="group flex flex-col p-6 bg-white rounded-lg border border-gray-200 hover:border-blue-500 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <MapPin className="h-5 w-5 text-blue-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-blue-600">
                    {area.label}
                  </h3>
                  {area.pincode && (
                    <p className="text-sm text-gray-500">
                      Pincode: {area.pincode}
                    </p>
                  )}
                </div>
                <ArrowRight className="h-5 w-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}